export default __webpack_public_path__ + "img/75e537293afdf3a8.a2776bc086f961abef98435afbf3b0d9.jpeg";